import { TablePagination } from "@mui/material";
const Pagination = ({ pagination, onPageChange, onRowsPerPageChange, stacks = [10, 20, 50, 100] }) => {
  return pagination && Object.keys(pagination)?.length && pagination?.total > 0 ? (
    <TablePagination
      rowsPerPageOptions={stacks}
      component="div"
      count={pagination?.total}
      rowsPerPage={pagination?.per_page}
      page={pagination?.page - 1}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      slotProps={{
        actions: {
          backButtonProps: { "aria-label": "previous page" },
          nextButtonProps: { "aria-label": "next page" },
        },
      }}
    />
  ) : null;
};
export default Pagination;
